export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14274.7a919bf8.jpg";